import { render } from "./ObjectiveLandingPage.vue?vue&type=template&id=48c8a137&scoped=true"
import script from "./ObjectiveLandingPage.vue?vue&type=script&lang=js"
export * from "./ObjectiveLandingPage.vue?vue&type=script&lang=js"

import "./ObjectiveLandingPage.vue?vue&type=style&index=0&id=48c8a137&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c8a137"]])

export default __exports__